export const crops = {
    state: {
        status: 'idle',
        crops: [],
        areAllFetched: false,
        pagination: {
            limit: 20,
            page: 1
        },
        query: {}
    },
    mutations: {
        SET_CROPS_STATUS(state, status) {
            state.status = status
        },
        SET_CROPS(state, crops) {
            state.crops = crops
        },
        SET_CROPS_QUERY(state, payload) {
            this.$vue.set(state.query, payload.name, payload.value)
        },
        SET_CROPS_PAGINATION_PAGE(state, page) {
            state.pagination.page = page
        },
        SET_CROPS_ALL_FETCHED(state, areAllFetched) {
            state.areAllFetched = areAllFetched
        }
    },
    actions: {
        fetchCrops({ state, commit, dispatch, getters }) {
            commit('SET_CROPS', [])
            commit('SET_CROPS_STATUS', 'loading')
            return dispatch('resetCropsPagination').then(() => {
                return this.$api.get(`api/crops.json?${getters.cropsQueryString}`).then((response) => {
                    commit('SET_CROPS', response.data.data)
                    commit('SET_CROPS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.crops.length : response.data.data.length === 0)
                    commit('SET_CROPS_STATUS', 'idle')
                    return response
                }).catch(error => {
                    commit('SET_CROPS_STATUS', 'error')
                    return Promise.reject(error)
                })
            })
        },
        fetchCropsNextPage({ state, commit, getters }) {
            if (state.areAllFetched) {
                return false
            }
            commit('SET_CROPS_STATUS', 'loadingMore')
            commit('SET_CROPS_PAGINATION_PAGE', state.pagination.page + 1)
            return this.$api.get(`api/crops.json?${getters.cropsQueryString}`).then((response) => {
                commit('SET_CROPS', state.crops.concat(...response.data.data))
                commit('SET_CROPS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.crops.length : response.data.data.length === 0)
                commit('SET_CROPS_STATUS', 'idle')
            }).catch(error => {
                commit('SET_CROPS_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        setCropsSearchQuery({ state, commit }, payload) {
            // check if payload has valid properties
            if (Object.prototype.hasOwnProperty.call(payload, 'name') &&
                Object.prototype.hasOwnProperty.call(payload, 'value')) {
                commit('SET_CROPS_QUERY', payload)
            } else {
                console.error('Invalid payload')
            }
        },
        resetCropsQuery({ commit, dispatch }) {
            commit('SET_CROPS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'crops',
                object: 'query'
            })
        },
        resetCropsPagination({ commit, dispatch }) {
            commit('SET_CROPS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'crops',
                object: 'pagination'
            })
        }
    },
    getters: {
        cropsStatus: (state) => {
            return state.status
        },
        crops: (state) => {
            if (state.crops) {
                return state.crops
            }
        },
        cropsQuery: (state) => {
            return state.query
        },
        cropsQueryString: (state) => {
            const pagination = `page=${state.pagination.page}&limit=${state.pagination.limit}`
            const params = Object.entries(state.query)
                .filter(([key, value]) => value !== '')
                .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
                .join('&')
            return `${pagination}&${params}`
        }
    }
}
